import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BookingCalendar from './BookingCalendar';

const { FiPhone, FiMail, FiCalendar, FiX, FiArrowRight } = FiIcons;

const ContactModal = ({ isOpen, onClose }) => {
  const [view, setView] = useState('menu'); // 'menu' | 'calendar'

  if (!isOpen) return null;

  const handleClose = () => {
    setView('menu');
    onClose();
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
        <motion.div 
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          className="bg-zinc-950 border-2 border-yellow-400 w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl flex flex-col max-h-[90vh]"
        >
          <div className="bg-yellow-400 p-6 flex justify-between items-center shrink-0">
            <h3 className="text-2xl font-black text-black uppercase tracking-tighter">
              {view === 'calendar' ? 'Schedule Call' : 'Get in Touch'}
            </h3>
            <button 
              onClick={handleClose}
              className="text-black hover:bg-black/10 p-2 rounded-full transition-colors"
            >
              <SafeIcon icon={FiX} className="h-6 w-6" />
            </button>
          </div>

          <div className="p-6 md:p-8 overflow-y-auto custom-scrollbar">
            {view === 'menu' ? (
              <div className="space-y-6">
                <p className="text-zinc-400 font-medium">
                  Connect with our experts to discuss your fleet requirements. No pricing is fixed until we understand your specific needs.
                </p>
                
                <div className="space-y-4">
                  <a 
                    href="tel:+17089602690" 
                    className="flex items-center p-4 bg-zinc-900 rounded-xl hover:bg-zinc-800 transition-colors border border-zinc-800 group"
                  >
                    <div className="bg-red-600 p-3 rounded-lg mr-4">
                      <SafeIcon icon={FiPhone} className="text-white h-5 w-5" />
                    </div>
                    <div>
                      <div className="text-xs text-zinc-500 uppercase font-bold tracking-wider">Call Us Now</div>
                      <div className="text-white font-bold text-lg">+1 (708) 960-2690</div>
                    </div>
                    <SafeIcon icon={FiArrowRight} className="ml-auto text-zinc-600 group-hover:text-yellow-400 transition-transform group-hover:translate-x-1" />
                  </a>

                  <a 
                    href="mailto:info@trukr.us" 
                    className="flex items-center p-4 bg-zinc-900 rounded-xl hover:bg-zinc-800 transition-colors border border-zinc-800 group"
                  >
                    <div className="bg-blue-600 p-3 rounded-lg mr-4">
                      <SafeIcon icon={FiMail} className="text-white h-5 w-5" />
                    </div>
                    <div>
                      <div className="text-xs text-zinc-500 uppercase font-bold tracking-wider">Email Support</div>
                      <div className="text-white font-bold text-lg">info@trukr.us</div>
                    </div>
                    <SafeIcon icon={FiArrowRight} className="ml-auto text-zinc-600 group-hover:text-yellow-400 transition-transform group-hover:translate-x-1" />
                  </a>

                  <button 
                    onClick={() => setView('calendar')}
                    className="w-full flex items-center p-4 bg-yellow-400 rounded-xl hover:bg-yellow-500 transition-colors border border-yellow-400 group"
                  >
                    <div className="bg-black p-3 rounded-lg mr-4">
                      <SafeIcon icon={FiCalendar} className="text-white h-5 w-5" />
                    </div>
                    <div className="text-left">
                      <div className="text-xs text-black/60 uppercase font-bold tracking-wider">Online Booking</div>
                      <div className="text-black font-bold text-lg">Schedule Intro Call</div>
                    </div>
                    <SafeIcon icon={FiArrowRight} className="ml-auto text-black/40 group-hover:text-black transition-transform group-hover:translate-x-1" />
                  </button>
                </div>
              </div>
            ) : (
              <BookingCalendar onBack={() => setView('menu')} />
            )}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default ContactModal;